module.exports = __webpack_public_path__ + "Roboto-Black.44236ad507eddcbfd986.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Black.ttf
// module id = 222
// module chunks = 2